export default "__VITE_ASSET__9Q6n7I2$__"